import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_APARTMENT_SPECIAL_DEAL_GET_LIST,
} from 'api/actionTypes';

export default async function getApartmentSpecialDealsByApartmentBuildingId(
  { state, apiClient },
  { apartmentBuildingId },
) {
  typeCheck('apartmentBuildingId::Number', apartmentBuildingId);

  const statePath = ['apartments', 'specialDealsByApartmentBuildingId', apartmentBuildingId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_SPECIAL_DEAL_GET_LIST,
    state: state,
    payload: {
      apartmentBuildingId: apartmentBuildingId,
    },
    onSuccess(apartmentSpecialDeals) {
      if (apartmentSpecialDeals) {
        state.set(statePath, apartmentSpecialDeals);
      }
    },
  });
}
